import { render, staticRenderFns } from "./productDetail.vue?vue&type=template&id=486819fa&scoped=true"
import script from "./productDetail.vue?vue&type=script&lang=js"
export * from "./productDetail.vue?vue&type=script&lang=js"
import style0 from "../../../static/css/productDetail.css?vue&type=style&index=0&id=486819fa&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486819fa",
  null
  
)

export default component.exports